import React, { useState } from 'react';
import { Search, Menu, X, User, ChevronDown } from 'lucide-react';
import { Link } from 'react-router-dom';
export const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  return <header className="bg-white shadow-sm sticky top-0 z-50" data-id="element-336">
      <div className="container mx-auto px-4" data-id="element-337">
        {/* Top header with contact and language */}
        <div className="hidden md:flex justify-between items-center py-2 text-sm border-b" data-id="element-338">
          <div className="flex items-center space-x-4" data-id="element-339">
            <span data-id="element-340">Need help? Call: +25170000000</span>
            <span data-id="element-341">|</span>
            <span data-id="element-342">Email: support@onestop.et</span>
          </div>
          <div className="flex items-center space-x-4" data-id="element-343">
            <a href="#" className="hover:text-blue-600" data-id="element-344">
              English
            </a>
            <span data-id="element-345">|</span>
            <a href="#" className="hover:text-blue-600" data-id="element-346">
              Amharic
            </a>
            <span data-id="element-347">|</span>
            <a href="#" className="hover:text-blue-600" data-id="element-348">
              Français
            </a>
          </div>
        </div>
        {/* Main header with logo and navigation */}
        <div className="flex justify-between items-center py-4" data-id="element-349">
          <Link to="/" className="flex items-center" data-id="element-350">
            <div className="font-bold text-2xl text-blue-700" data-id="element-351">
              <img className="object-contain" style={{
              width: '200px',
              height: '120px'
            }} src="https://eu2.contabostorage.com/b9e17f24bf0f4437b03607562b167cff:image/default/onestop.jpg" data-id="element-96" />
            </div>
          </Link>
          <div className="hidden md:flex items-center space-x-6" data-id="element-352">
            {/* Search bar */}
            <div className="relative" data-id="element-353">
              <input type="text" placeholder="Search services..." className="pl-10 pr-4 py-2 border rounded-lg w-64 focus:outline-none focus:ring-2 focus:ring-blue-500" data-id="element-354" />
              <Search className="absolute left-3 top-2.5 h-5 w-5 text-gray-400" data-id="element-355" />
            </div>
            {/* Navigation links */}
            <nav className="flex items-center space-x-6" data-id="element-356">
              <Link to="/" className="font-medium hover:text-blue-600" data-id="element-357">
                Home
              </Link>
              <div className="relative group" data-id="element-358">
                <button className="flex items-center font-medium hover:text-blue-600" data-id="element-359">
                  Services <ChevronDown className="ml-1 h-4 w-4" data-id="element-360" />
                </button>
                <div className="absolute left-0 mt-2 w-48 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-300" data-id="element-361">
                  <div className="py-1" data-id="element-362">
                    <Link to="/services/business" className="block px-4 py-2 text-sm hover:bg-gray-100" data-id="element-363">
                      Business Services
                    </Link>
                    <Link to="/services/citizens" className="block px-4 py-2 text-sm hover:bg-gray-100" data-id="element-364">
                      Citizen Services
                    </Link>
                    <Link to="/services/immigration" className="block px-4 py-2 text-sm hover:bg-gray-100" data-id="element-365">
                      Immigration
                    </Link>
                    <Link to="/services/taxes" className="block px-4 py-2 text-sm hover:bg-gray-100" data-id="element-366">
                      Tax Services
                    </Link>
                  </div>
                </div>
              </div>
              <Link to="/about" className="font-medium hover:text-blue-600" data-id="element-367">
                About
              </Link>
              <Link to="/help" className="font-medium hover:text-blue-600" data-id="element-368">
                Help
              </Link>
              <Link to="/contact" className="font-medium hover:text-blue-600" data-id="element-369">
                Contact
              </Link>
            </nav>
            {/* Login button */}
            <Link to="/login" className="flex items-center px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors" data-id="element-370">
              <User className="h-4 w-4 mr-2" data-id="element-371" />
              Login / Register
            </Link>
          </div>
          {/* Mobile menu button */}
          <button className="md:hidden" onClick={() => setIsMenuOpen(!isMenuOpen)} data-id="element-372">
            {isMenuOpen ? <X className="h-6 w-6" data-id="element-373" /> : <Menu className="h-6 w-6" data-id="element-374" />}
          </button>
        </div>
        {/* Mobile menu */}
        {isMenuOpen && <div className="md:hidden py-4 border-t" data-id="element-375">
            <div className="flex justify-center pb-4" data-id="element-376">
              <div className="relative w-full px-4" data-id="element-377">
                <input type="text" placeholder="Search services..." className="pl-10 pr-4 py-2 border rounded-lg w-full focus:outline-none focus:ring-2 focus:ring-blue-500" data-id="element-378" />
                <Search className="absolute left-7 top-2.5 h-5 w-5 text-gray-400" data-id="element-379" />
              </div>
            </div>
            <nav className="flex flex-col space-y-3 px-4" data-id="element-380">
              <Link to="/" className="font-medium py-2 hover:text-blue-600" data-id="element-381">
                Home
              </Link>
              <Link to="/services" className="font-medium py-2 hover:text-blue-600" data-id="element-382">
                Services
              </Link>
              <Link to="/about" className="font-medium py-2 hover:text-blue-600" data-id="element-383">
                About
              </Link>
              <Link to="/help" className="font-medium py-2 hover:text-blue-600" data-id="element-384">
                Help
              </Link>
              <Link to="/contact" className="font-medium py-2 hover:text-blue-600" data-id="element-385">
                Contact
              </Link>
              <div className="pt-2" data-id="element-386">
                <Link to="/login" className="flex items-center justify-center w-full px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors" data-id="element-387">
                  <User className="h-4 w-4 mr-2" data-id="element-388" />
                  Login / Register
                </Link>
              </div>
            </nav>
          </div>}
      </div>
    </header>;
};